<div style="height: 100%; box-sizing: border-box;">
    <mat-card style="height: 100%; box-sizing: border-box; padding:0">
        <file-manager [fileElements]="fileElements | async" [path]="currentPath" [canNavigateUp]="canNavigateUp"
            (folderAdded)="addFolder($event)" (fileAdded)="addFile($event)" (elementRemoved)="removeElement($event)"
            (navigatedDown)="navigateToFolder($event)" (navigatedUp)="navigateUp()"
            (elementRenamed)="renameElement($event)" (elementMoved)="moveElement($event)" (fileChoose)="fileChoose($event)"></file-manager>
    </mat-card>
</div>